<template>
	<div>
		<section>
			<InfoForm :customerId="customerId" :sourceType="sourceType" />
		</section>
		<section style="padding: 0 16px; box-sizing: border-box;">
			<el-tabs v-model="activeName">
				<el-tab-pane v-if="sourceType !== 'customerInfo'" label="沟通小结" name="first"></el-tab-pane>
				<el-tab-pane label="沟通历史" name="second"></el-tab-pane>
				<el-tab-pane label="变更记录" name="third" v-if="$store.getters.userInfo.brandIdentify != brandName"></el-tab-pane>
				<el-tab-pane label="外呼任务列表" name="fourth" v-if="$store.getters.userInfo.brandIdentify == brandName && sourceType == 'tel'"></el-tab-pane>
				<el-tab-pane :label="item.tabName" :name="item.tabId" v-for="(item, index) in tabList" :key="index">
					<Table v-if="activeName == item.tabId" :item="item" :customerId="customerId" />
				</el-tab-pane>
			</el-tabs>
		</section>
		<Summary :customerId="customerId" :tuId="tuId" :sourceType="sourceType" v-if="activeName === 'first'" />
		<History :customerId="customerId" :tuId="tuId" :sourceType="sourceType" v-if="activeName === 'second'" />
		<Log :customerId="customerId" :sourceType="sourceType" v-if="activeName === 'third'" />
		<TaskComponent v-if="activeName === 'fourth'" :customerId="customerId" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import InfoForm from "./info";
import Summary from "./summary";
import History from "./history";
import Log from "./log";
import Table from "./table";
import TaskComponent from '@/views/breathe/task/taskComponent.vue';

export default {
	name: 'ComponentCustomerInfo',
	computed: {
        ...mapGetters([
			'userInfo',
        ])
    },
	props: ['sourceType', 'customerId', 'tuId'],
	data () {
		return {
			activeName: this.sourceType === 'customerInfo' ? 'second' : 'first',
			brandName:process.env.VUE_APP_BRANDNAME,
			tabList: [],
		};
	},
	created() {
		this.getTabList();
	},
	methods: {
		getTabList() {
			this.$api.apiPostCustomerInfo({brand: this.userInfo.brandIdentify, customerId: this.customerId}).then(res => {
				if(res.errcode != 0) return;
				this.$api.apiGetTabList({channel: res?.data?.[0]?.channel || ''}).then(response => {
					if(response.errcode != 0) return;
					this.tabList = response?.data || [];
				});
			});
		},
	},
	components: {
		InfoForm,
		Summary,
		History,
		Log,
		TaskComponent,
		Table
	}
}
</script>